var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"screen screen__products",attrs:{"direction":"vertical"}},[_c('home-marquee'),_vm._v(" "),_c('regional-highlights'),_vm._v(" "),_c('home-favorites'),_vm._v(" "),_c('home-product-info'),_vm._v(" "),(_vm.supportedFeaturesTraining)?_c('home-sales-training'):_vm._e(),_vm._v(" "),_c('footer-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }